import store from 'Redux/store';

// TODO WTF is this?

const GAnalyticsRedux = (product) => {
  if (product) {
    if ((product.sold_out || product.region_locked) && !product.presale) {
      store.dispatch({
        type: 'frontend/out-of-stock/OUT_OF_STOCK',
        payload: { sold_out: true, wrong_region: product.region_locked || false },
      });
    }

    if (product._id) {
      store.dispatch({ type: 'frontend/product-viewed/PRODUCT_VIEWED', payload: { productId: product._id } });
    }
  }

  return true;
};

export default GAnalyticsRedux;
